import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5a86ce68")

_pushScopeId("data-v-5a86ce68")
const _hoisted_1 = { class: "InvoiceBasicDelivery" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", { class: "InvoiceBasicDelivery__title" }, "Информация о доставке", -1)
const _hoisted_3 = { class: "InvoiceBasicDelivery__body" }
const _hoisted_4 = {
  key: 0,
  class: "body__block"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("p", { class: "block__subtext" }, "Номер накладной заказчика", -1)
const _hoisted_6 = { class: "block__text" }
const _hoisted_7 = {
  key: 1,
  class: "body__block"
}
const _hoisted_8 = /*#__PURE__*/_createVNode("p", { class: "block__subtext" }, "Наименование товара", -1)
const _hoisted_9 = { class: "block__text" }
const _hoisted_10 = { class: "body__block" }
const _hoisted_11 = /*#__PURE__*/_createVNode("p", { class: "block__subtext" }, "Тип доставки", -1)
const _hoisted_12 = { class: "block__text" }
const _hoisted_13 = { class: "body__block" }
const _hoisted_14 = /*#__PURE__*/_createVNode("p", { class: "block__subtext" }, "Направление", -1)
const _hoisted_15 = { class: "block__text" }
const _hoisted_16 = { class: "body__block" }
const _hoisted_17 = /*#__PURE__*/_createVNode("p", { class: "block__subtext" }, "Объёмный вес", -1)
const _hoisted_18 = {
  key: 0,
  class: "block__text"
}
const _hoisted_19 = /*#__PURE__*/_createVNode("sup", null, "3", -1)
const _hoisted_20 = {
  key: 1,
  class: "block__text"
}
const _hoisted_21 = { class: "body__block" }
const _hoisted_22 = /*#__PURE__*/_createVNode("p", { class: "block__subtext" }, "Физический вес", -1)
const _hoisted_23 = {
  key: 0,
  class: "block__text"
}
const _hoisted_24 = {
  key: 1,
  class: "block__text"
}
const _hoisted_25 = { class: "body__block" }
const _hoisted_26 = /*#__PURE__*/_createVNode("p", { class: "block__subtext" }, "Количество мест", -1)
const _hoisted_27 = { class: "block__text" }
const _hoisted_28 = {
  key: 2,
  class: "body__block"
}
const _hoisted_29 = /*#__PURE__*/_createVNode("p", { class: "block__subtext" }, "Стоимость доставки", -1)
const _hoisted_30 = { class: "block__text" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      (Boolean(_ctx.invoiceState.data.dop_invoice_number))
        ? (_openBlock(), _createBlock("div", _hoisted_4, [
            _hoisted_5,
            _createVNode("p", _hoisted_6, _toDisplayString(_ctx.invoiceState.data.dop_invoice_number), 1)
          ]))
        : _createCommentVNode("", true),
      (Boolean(_ctx.invoiceState.data.product_name))
        ? (_openBlock(), _createBlock("div", _hoisted_7, [
            _hoisted_8,
            _createVNode("p", _hoisted_9, _toDisplayString(_ctx.invoiceState.data.product_name), 1)
          ]))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_10, [
        _hoisted_11,
        _createVNode("p", _hoisted_12, _toDisplayString(_ctx.invoiceState.data.shipment_type), 1)
      ]),
      _createVNode("div", _hoisted_13, [
        _hoisted_14,
        _createVNode("p", _hoisted_15, _toDisplayString(_ctx.invoiceState.data.direction), 1)
      ]),
      _createVNode("div", _hoisted_16, [
        _hoisted_17,
        (_ctx.invoiceState.data.volume_weight)
          ? (_openBlock(), _createBlock("p", _hoisted_18, [
              _createTextVNode(_toDisplayString(_ctx.invoiceState.data.volume_weight) + " кг/м", 1),
              _hoisted_19
            ]))
          : (_openBlock(), _createBlock("p", _hoisted_20, "Не указан"))
      ]),
      _createVNode("div", _hoisted_21, [
        _hoisted_22,
        (_ctx.invoiceState.data.weight)
          ? (_openBlock(), _createBlock("p", _hoisted_23, _toDisplayString(_ctx.invoiceState.data.weight) + " кг ", 1))
          : (_openBlock(), _createBlock("p", _hoisted_24, "Не указан"))
      ]),
      _createVNode("div", _hoisted_25, [
        _hoisted_26,
        _createVNode("p", _hoisted_27, _toDisplayString(_ctx.invoiceState.data.places) + " " + _toDisplayString(_ctx.declOfNum(_ctx.invoiceState.data.places, _ctx.PLACES_TOKENS)), 1)
      ]),
      (_ctx.invoiceState.data.billing_enabled)
        ? (_openBlock(), _createBlock("div", _hoisted_28, [
            _hoisted_29,
            _createVNode("p", _hoisted_30, _toDisplayString(_ctx.getCostPrediction(
                            _ctx.invoiceState.data.cost_prediction,
                            _ctx.invoiceState.data.status_code
                        )), 1)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
})